import ClientTabs from "./Tabs";
import {
    Paper,
    Title,
  } from "@mantine/core";
import "./index.css";
import { useMedplum } from "@medplum/react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { normalizeErrorString } from "@medplum/core";
import { showNotification } from "@mantine/notifications";

function ClientDetails (): JSX.Element {

    const medplum = useMedplum();
    const { clientId, resourceType }:any = useParams();
    const [clientDetails, setClientDetails] = useState<any>({})

    useEffect(()=>{
        getClientDetails()
    },[])

    const getClientDetails = () => {
        medplum.readResource(resourceType, `${clientId}`)
        .then((res:any)=>{
            setClientDetails(res)
        })
        .catch((err) => {
            showNotification({ color: 'red', message: normalizeErrorString(err), autoClose: true });
          });
    }

    return (
        <>
            <ClientTabs 
                currentTab={"Details"}
                clientName={clientDetails?.name}
            />
            <Paper
                sx={{
                    marginTop: "20px",
                    marginBottom: "40px",
                    borderRadius: "8px",
                    marginLeft: "40px",
                    marginRight: "40px",
                    padding: "20px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                }}
            >
            <Title size="h2">Client Details</Title>
            <div className="detailsWrap">
                <div className="clientHeader">
                    Client ID
                </div>
                <div className="clientData">
                    {clientDetails?.id}
                </div>
            </div>
            <div className="detailsWrap">
                <div className="clientHeader">
                    Name
                </div>
                <div className="clientData">
                    {clientDetails?.name}
                </div>
            </div>
            <div className="detailsWrap">
                <div className="clientHeader">
                    Secret
                </div>
                <div className="clientData">
                    {clientDetails?.secret}
                </div>
            </div>
            <div className="detailsWrap">
                <div className="clientHeader">
                    Description
                </div>
                <div className="clientData">
                    {clientDetails?.description}
                </div>
            </div>
        </Paper>
        </>
    )

}

export default ClientDetails